export default __webpack_public_path__ + "static/mehrstufig-hybrid-national-d85c3eebd7b6a6080d14ed29fe6346c7.jpg";